<template>
    <div class="article-blog-attending">
        <p><em>Here's our action-packed plan of WSDC events for the coming year and beyond.</em></p>
        <p>
            These events offer world class teaching line-ups, official competitions and late-night socials you won't
            forget. We'd love you to get involved.
        </p>
        <p>
            If you're nervous about attending such a big event, why not set Detonation in April as a goal and structure
            your practice in the meantime?
        </p>
        <h3>Midland Swing Open - 26 September 2025, London, England</h3>
        <p>
            One of the longest running WSDC events in Europe,
            <a href="https://www.midlandswingopen.com/" target="_blank" rel="noopener noreferrer nofollow"
                >Midland Swing Open</a
            >
            is an event attracting some excellent teachers and dancers.
        </p>
        <h3>Milan Modern Swing - 9 October 2025, Milan, Italy</h3>
        <p>
            A first for us this year -
            <a href="https://www.westcoastswingmilan.com/" target="_blank" rel="noopener noreferrer nofollow"
                >Milan Modern Swing</a
            >
            is set in the fashion capital of the world. Packed with intensives and workshops from a fantastic teaching
            line up, you can make some real progress in your dancing here.
        </p>
        <h3>Autumn Swing Challenge - 7 November 2025, Budapest, Hungary</h3>
        <p>
            We’ve been going to
            <a href="https://www.asc-budapest.com/" target="_blank" rel="noopener noreferrer nofollow"
                >Autumn Swing Challenge</a
            >
            for four years now, and it’s really become a favourite of ours. With a very friendly atmosphere, the thermal
            spa hotel, and direct flights from Leeds, it’s an easy choice.
        </p>
        <h3>Warsaw Halloween Swing - 31 October 2025, Warsaw, Poland</h3>
        <p>
            For those who love to dress up,
            <a href="https://warsawhalloweenswing.com/" target="_blank" rel="noopener noreferrer nofollow"
                >Warsaw Halloween Swing</a
            >
            is a non-negotiable event in the calendar. Spooky strictly, costume parade, and the wild all-European Jack
            &amp; Jill make this event a blast. Not to mention some of
            <a
                href="https://www.affinityswing.com/videos/448?context=event&amp;eventSlug=warsaw-halloween-swing&amp;idCollection=18"
                target="_blank"
                rel="noopener noreferrer nofollow"
                >the best pro shows we've ever seen</a
            >.
        </p>
        <h3>Budafest - 6 January 2026, Budapest, Hungary</h3>
        <p>
            <a href="https://wcs-budafest.com/" target="_blank" rel="noopener noreferrer nofollow">Budafest</a> needs no
            introduction, one of the biggest events in Europe with some of the best names in the business, Budafest is
            where the stuff of WCS Legend is made. Go for the weekend or the whole week, and completely immerse yourself
            in the world of West Coast Swing!
        </p>
        <h3>Trinity Swing 2026 - 6 February 2026, Dundalk, Ireland</h3>
        <p>
            After a successful trial event in 2025,
            <a href="https://www.trinityswing.com/" target="_blank" rel="noopener noreferrer nofollow">Trinity Swing</a>
            is back for its second year. We love this event for its gorgeous countryside location, spa hotel, and
            intimate workshops. Plus there's a couple opportunities to get out on a walking tour, ending at a
            traditional Irish pub for a pint of Guinness and some great craic.
        </p>
        <h3>UK West Coast Swing Championships - 26 March 2026, London, England</h3>
        <p>
            The return of the
            <a href="https://www.ukwcschamps.com/" target="_blank" rel="noopener noreferrer nofollow"
                >UK West Coast Swing Championships</a
            >
            after a 5 year hiatus in 2025 did not disappoint.
            <a
                href="https://www.affinityswing.com/videos/532?context=event&amp;eventSlug=uk-wcs-champs&amp;idCollection=36"
                target="_blank"
                rel="noopener noreferrer nofollow"
                >Our favourite part was sipping tea with the world champs</a
            >. One of the biggest events in the UK, with an incredible line up, you simply can't miss it. Plus you might
            win a teapot.
        </p>
        <h3>Detonation Dance - 23 April 2026, Manchester, England</h3>
        <p>
            Pretty much our home event,
            <a href="https://detonationdance.com/" target="_blank" rel="noopener noreferrer nofollow">Detonation</a> is
            a firm favourite and well-attended by our community. Only an hour away from Leeds, Detonation Dance is an
            excellent choice for your first event.
        </p>
        <p>
            <em>If you want to join us, simply </em
            ><a href="/contact/" class="" rel="noopener noreferrer nofollow"><em>drop us a message</em></a
            ><em>
                and we'll add you to the relevant groups for each event. Worried about attending such a big event? No
                worries, we'll explain everything!</em
            >
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleBlogAttending',
};
</script>
